// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3867c6cc","496":"46d5928b","498":"aea110cb","657":"d261f534","787":"235e9fed"}[chunkId] + ".chunk.js";
};